import clsx from 'clsx'
import React from 'react'
import Box from '@mui/material/Box'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import Fade from '@mui/material/Fade'
import {faEdit} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Button from './button'

export default function Premise (props) {

  const {context, onPremiseChange} = props
  const {translate} = context
  const [editing, setEditing] = React.useState(true)
  const [premise, setPremise] = React.useState(props.premise)
  const editPremise = React.useRef()

  function handleChange (e) {
    setPremise(e.target.value)
  }

  function handleSave () {
    if (props.premise != premise) {
      onPremiseChange && onPremiseChange(premise)
    }
  }

  function handleCancel () {
    setPremise(props.premise)
  }

  React.useEffect(() => {
    if (premise != props.premise) {
      setPremise(props.premise || '')
    }
  }, [props.premise])

  return (
    <React.Fragment>
      {editing && (<Box className={clsx('edit-premise', {editing})}>
        <Box className="comments">
          <TextareaAutosize
            ref={editPremise}
            maxRows={5}
            minRows={5}
            value={premise}
            onKeyPress = {({key}) => {
              key == 'Enter' && handleSave()
            }}
            onChange={handleChange}
            onBlur={handleSave}
          />
        </Box>
      </Box>)}
      {!editing && (<Box className={clsx('view-premise', {editing})}>
        <Box className="header">
          <span className="edit-icon" onClick={() => { setEditing(true) }}>
            <FontAwesomeIcon icon={faEdit} />
          </span>
        </Box>
        <Box className="comments" onClick={() => { setEditing(true)}}>
            <TextareaAutosize
              maxRows={5}
              minRows={5}
              value={premise}
              readOnly
            />
          </Box>
      </Box>)}
    </React.Fragment>
  )
}
